export default "__VITE_ASSET__47c66ba6__"